<template>
	<div class="box" :class="visible ? 'visible-transition scale' : 'invisible-transition scale'">
		<img class="qoute" src="../assets/img/icons/quote.svg">

		<h3>
			A good start<br>makes for a<br>great future
		</h3>

		<p class="box-name">
			Jan Åström
			<span>
				President and CEO
			</span>
		</p>

		<a 	:href="$creo.browserPdfLink(pdfLinks.full, pdfLinks.ceo, 10)"
				class="btn btn-ceo"
				target="_blank">
			Read the CEO comment in full
		</a>
	</div>
</template>

<script>
	import full from '../assets/pdf/full-report.pdf';
	import ceo from '../assets/pdf/ceo.pdf';

	export default {
		data() {
      return {
        pdfLinks: {
          'full': full,
          'ceo': ceo
        }
      }
    },
		props: {
	    visible: {
        default: () => false
	    }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Box.vue